import notificatorConstants, { NOTIFICATION_TYPES } from './constants';

const initialState = {
  type: '',
  message: ''
};

const notificatorReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case notificatorConstants.SHOW_SUCCESS_NOTIFICATION:
      return {
        id: payload.id,
        type: NOTIFICATION_TYPES.SUCCESS,
        message: payload.message
      };
  
    case notificatorConstants.SHOW_ERROR_NOTIFICATION:
      return {
        id: payload.id,
        type: NOTIFICATION_TYPES.ERROR,
        message: payload.message
      };

    default:
      return state;
  }
};

export default notificatorReducer;
